import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Plus, Snowflake } from 'lucide-react';
import { ChallengeMe, ChallengeSummary, profileChallengeModel } from '@radevents/shared';
import { QuickRideDialog } from './QuickRideDialog';
import './winterchallenge.css';

/**
 * Die eigene Winterchallenge im Kopf des Profils, nur für Teilnehmer. Steht auf dem dunklen
 * Verlauf der Profilkarte. Während der Saison öffnet sie das Schnellfenster zum Eintragen
 * (`QuickRideDialog`), sonst führt sie auf die Challenge-Seite.
 */
export function ProfileChallenge({ me, summary, today, onSaved }: {
  me: ChallengeMe;
  summary: ChallengeSummary;
  today: string;
  onSaved?: (next: ChallengeMe) => void;
}) {
  const [open, setOpen] = useState(false);
  const m = profileChallengeModel(me, summary, today);
  const body = (
    <>
      <span className="wc-profile-kicker"><Snowflake size={12} aria-hidden />{m.title}</span>
      <span className="wc-profile-km"><strong>{m.km}</strong> km</span>
      <span className="wc-profile-detail">{m.detail}</span>
      {m.percent != null && (
        <span className="wc-profile-bar"><span style={{ width: `${m.percent}%` }} /></span>
      )}
      <span className={`wc-profile-cta${m.addRide ? ' wc-cue wc-cue--light' : ''}`}>
        {m.addRide && <Plus size={15} aria-hidden />}{m.action}{!m.addRide && <ArrowRight size={15} aria-hidden />}
      </span>
    </>
  );
  if (!m.addRide) return <Link to="/winterchallenge" className="wc-profile">{body}</Link>;
  return (
    <>
      <button type="button" className="wc-profile" onClick={() => setOpen(true)}>{body}</button>
      {open && <QuickRideDialog me={me} summary={summary} today={today} onSaved={onSaved} onClose={() => setOpen(false)} />}
    </>
  );
}
